// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__eAjgU","featured":"Card_featured__zBuDW"};